<template>
  <div class="menu-list-wrapper">
    <ul v-if="menuData.length" class="nav-top">
      <li v-for="(item) in menuData" :id="item.id" :key="item.id" @mouseenter="onHover(item)" :class="curMenu && curMenu.id === item.id ? 'active' : ''" @click="openMenu(item)">
        <i class="iconfont" :class="icons[item.code] || 'icon-home'"></i>
        <span class="name">{{ item.name }}</span>
        <menu-popup class="popup" :itemData="item.data" :width="item.type === 'more' ? '204px' : 'auto'" :type="item.type" @openMenu="openMenu" />
      </li>
    </ul>

    <ul v-if="infoData.length" class="nav-bottom">
      <li v-for="(item) in infoData" :id="item.id" :key="item.id" @click="openMenu(item)">
        <img class="download" v-if="item.code === 'download' && item.runCount" src="../../assets/images/download.gif" alt="">
        <img class="download" v-if="item.code === 'download' && !item.runCount" src="../../assets/images/download.png" alt="">
        <img class="download" v-if="item.code === 'locale'" :src="locale ==='zh_CN' ? 'https://static.service.z-trip.cn/resources/pic/1252174733772-b444c33c-e010-4466-8ad3-c843d567c490.svg' : 'https://static.service.z-trip.cn/resources/pic/1252174600738-71340460-af4f-4a54-b563-acdb4ccadfaa.svg'" alt="">

        <i class="iconfont" v-if="item.code !== 'download'" :class="item.code"></i>
        <span class="downloadNumber" v-if="item.downloadNumber">{{ item.downloadNumber }}</span>
        <span class="msg" v-if="item.code === 'download'">{{ $t('MENUSLIDE.xia-zai-zhong-xin') }}</span>
        <span class="msg" v-if="item.code === 'icon-xiaoxi'">{{$t('MENUSLIDE.xiao-xi-zhong-xin')}}</span>
        <span class="msg" v-if="item.code === 'locale'">{{locale === 'zh_CN' ? '中文' : 'English'}}</span>
        <span class="me" v-if="item.code === 'icon-geren'">{{$t('MENUSLIDE.ge-ren')}}</span>
        <span class="name">{{ item.name }}</span>
        <menu-popup class="popup" height="180px" width="386px" :itemData="item.data" :item="item" @openMenu="openMenu" position="bottom" :showLogout="true" />
      </li>
    </ul>
  </div>
</template>

<script>
  import MenuPopup from './menuPopup'
  import {inject} from "vue";
  import { menueEentMap } from './menuEvent'
  const {locale, updateLocale} = window.I18N_CONFIGURATION
  export default {
    name: 'menuWrapper',
    components: {MenuPopup},
    props: {
      menuData: {
        type: Array,
        default: () => []
      },
      // 个人中心
      infoData: {
        type: Array,
        default: () => []
      }
    },
    setup(){
      const changeType = inject('changeType');
      return{
        changeType
      }
    },
    data() {
      return {
        locale: locale,
        curMenu: null, // 当前菜单
        icons: {
          'home': 'icon-home',
          'TRAVEL_PLAN': 'icon-chalvshenqing',
          'TRAVEL_BOOKING': 'icon-booking',
          'personal_center': 'icon-geren',
          'CONTROL_CENTER': 'icon-manange',
          'SETTING_CENTER': 'icon-shezhi',
          'icon-more': 'icon-gengduo',
          'PC_EXPENSE': 'icon-baoxiao1'
        }
      }
    },
    methods: {
      openMenu(item, itemParent = null, event) {
        if(item.data) return
        if(item.code === 'locale') {
          if(this.locale === 'zh_CN') {
            updateLocale('en-US')
          } else {
            updateLocale('zh-CN')
          }
          return
        }
        if(item.code ==='TRAVEL_PLAN' && window.$ZConfig.getVal('PC_TRAVEL_REQUEST_LINK')) {
          window.open(window.$ZConfig.getVal('PC_TRAVEL_REQUEST_LINK'))
          return
        } 
        // if (item.code === 'RISK_CONTROL') {
        //   window.open('/v/pg/oper/risk/workspace')
        //   return
        // }
        if (item.code === 'download') {
          window.$jump.to('/v/pg/oper/liquidation/downloadCenter/index')
          return
        }
        // 通知中心特殊处理
        if (item.code === 'icon-xiaoxi') {
          window.$jump.to('/v/notify/message.html')
          return
        }
        // 审批特殊处理
        if (item.code === 'Approve') {
          window.$jump.to('/v/notify/message/loadUnDoTask.html')
          return
        }
        if (item.trans && item.trans.code === 'TRE_PARTNER_ACCOUNT') {
          window.$jump.to('/v/vcommon/companyAccount/index')
          return
        }
        if (item.trans && item.trans.code === 'QUESTIONNAIRE') {
          window.open(item.trans.def)
          return
        }
        if (event) { // 阻止a标签跳转
          event.preventDefault()
        }
        this.curMenu =  item || itemParent
        let url = this.getToUrl(item)
        this.changeType(url, item.openMode)
        document.title = this.$parent.userInfo.partnerName + "-" + this.curMenu.name
      },

      /**
       * 获取跳转url
       * @param item
       * @returns {null}
       */
      getToUrl(item) {
        let url = this.getMenuUrl(item)
        if (!url) {
          // this.$Message.info('该菜单地址未定义');
          return null
        }
        if (item.appendix) {
          url += '?' + item.appendix
        }
        if (!url.startsWith('/')) {
          url = '/' + url
        }
        if (url.startsWith('/vexpense')) {
          url = url.replace('vexpense', 'expense')
        }

        if (url && url.includes('/vcommon/jsp')) {
          url = url.replace('/vcommon/jsp', '')
        }
        return url
      },

      getMenuUrl(menu) {
        if (menu.code === 'TRAVEL_PLAN') {
          
          return '/common/plan/planIndex'
        }
        return menu.trans ? menu.trans.def : menu.def || menu.url
      },

      onHover (item) {
        let arr = ['TRAVEL_BOOKING', 'CONTROL_CENTER']
        if (arr.includes(item.code) && item.id && menueEentMap[item.id]) {
          window.$ztDataAction.push({
            action: 'aplus.record',
            arguments: [menueEentMap[item.id], 'CLK']
          });
        }
      }
    }
  }
</script>

<style scoped lang="scss">
  .menu-list-wrapper {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    width: 100%;
    height: calc(100% - 110px);
    box-sizing: border-box;
    ul {
      flex: 1;
      width: 100%;
      /*display: inline-flex;*/
      flex-direction: column;
      align-items: center;
      justify-content: flex-start;
      li {
        position: relative;
        margin-bottom: 8px;
        width: 100%;
        height: 64px;
        display: inline-flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        i {
          font-size: 22px;
        }
        .downloadNumber {
          position: absolute;
          top: 4px;
          right: 10px;
          display: inline-flex;
          width: 20px;
          height: 20px;
          border-radius: 10px;
          background-color: red;
          color: #fff;
          font-size: 10px;
          align-items: center;
          justify-content: center;
        }
        .download {
          width: 22px;
          height: 22px;
        }
        span {
          font-size: 14px;
          color: #fff;
          font-weight: 500;
        }
        .me, .msg {
          display: none;
        }
      }
      li:hover, li.active {
        border-radius: 8px;
        background-color: #3E4452;
      }
      li:hover .popup {
        display: block;
      }
      li:hover .me, li:hover .msg {
        position: absolute;
        display: block;
        bottom: -10px;
        left: 50%;
        transform: translateX(-50%);
        width: 50px;
        height: 32px;
        line-height: 32px;
        text-align: center;
        align-items: center;
        justify-content: center;
        color: #666;
        font-size: 14px;
        border-radius: 3px;
        background-color: #fff;
      }
      li:hover .msg {
        width: 68px;
      }
      @media (max-height: 716px) {
        li {
          position: relative;
          margin-bottom: 2px;
          width: 100%;
          height: 42px;
          display: inline-flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          cursor: pointer;
          .downloadNumber {
            position: absolute;
            top: -9px;
            right: 12px;
            display: inline-flex;
            width: 20px;
            height: 20px;
            border-radius: 10px;
            background-color: red;
            color: #fff;
            font-size: 10px;
            align-items: center;
            justify-content: center;
          }
          i {
            font-size: 12px;
          }
          .download {
            width: 16px;
            height: 16px;
          }
          span {
            font-size: 12px;
            color: #fff;
            font-weight: normal;
          }
          .me, .msg {
            display: none;
          }
        }
        li:hover, li.active {
          border-radius: 6px;
          background-color: #3E4452;
        }
        li:hover .popup {
          display: block;
        }
        li:hover .me, li:hover .msg {
          position: absolute;
          display: block;
          bottom: -10px;
          left: 50%;
          transform: translateX(-50%);
          width: 50px;
          height: 32px;
          line-height: 32px;
          text-align: center;
          align-items: center;
          justify-content: center;
          color: #666;
          font-size: 14px;
          border-radius: 3px;
          background-color: #fff;
        }
        li:hover .msg {
          width: 68px;
        }

      }
    }
    .nav-bottom{
      li {
        position: relative;
        height: 50px;
      }
    }
    .nav-top {
      flex: 1;
    }
    .nav-top.scroll-y {
      flex: 1;
      overflow-y: scroll;
      overflow-x: auto;
      overflow-y: visible;
      scrollbar-width: none;
      -ms-overflow-style: none;
    }
    .nav-top.scroll-y::-webkit-scrollbar {
      display: none;
    }
    @media (max-height: 716px) {
      .nav-top {
        flex: 1;
        overflow-y: scroll;
        overflow-x: auto;
        overflow-y: visible;
        scrollbar-width: none;
        -ms-overflow-style: none;
      }
      .nav-top::-webkit-scrollbar {
        display: none;
      }
      .nav-bottom {
        padding: 10px 0 28px 0!important;
        flex: 0 0 108px!important;
        height: 108px!important;
        box-sizing: border-box;
        li:last-child {
          margin-bottom: 0;
        }
      }
    }
    .nav-bottom {
      // padding-bottom: 20px;
      display: flex;
      justify-content: flex-end!important;
      // padding: 20px 0 10px 0;
      // flex: 0 0 140px;
      // height: 214px;
      box-sizing: border-box;
      li {
        margin-bottom: 0;
      }
    }
  }
  @media (max-height: 716px) {
    .menu-list-wrapper {
      height: calc(100% - 70px);
    }
  }
</style>
